// Syncronize Filter
// =================

class SyncFilter {
    constructor(filter, target) {
        target.value = filter.value;
        target.addEventListener('change', () => {
            filter.value = target.value;
            filter.onChange();
        });
        window.addEventListener('popstate', () => {
            target.value = filter.value;
        });
    }
}

export default SyncFilter;
